export default __webpack_public_path__ + "static/media/Note_Dark.2fee1881.svg";